import React, { useState, useMemo } from "react";
import { Form, Table, Row, Col, Button } from "react-bootstrap";
import Layout from "../../layout/Layout";
import "../../styles/StandardDocument.css";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function SteelOneBPlani() {
  const [parsedData, setParsedData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);

  //  Sabit ürün ve ülke listeleri
  const productList = useMemo(
    () => [
      "Non alloy and alloy hot rolled sheets - A",
      "Non alloy and alloy cold rolled sheets",
      "Electrical sheets - A",
      "Electrical sheets - B",
      "Metallic coated sheets - A",
      "Metallic coated sheets - B",
      "Organic coated sheets",
      "Tin mill products",
      "Quarto plates",
      "Stainless hot rolled sheets and strips",
      "Stainless cold rolled sheets and strips",
      "Stainless hot rolled quarto plates",
      "Non alloy and other alloy merchant bars and light sections",
      "Rebars",
      "Stainless bars and light sections",
      "Stainless wire rod",
      "Non alloy and other alloy wire rod",
      "Angles and sections",
      "Sheet piling",
      "Railway material",
      "Gas pipes",
      "Hollow sections",
      "Seamless stainless tubes",
      "Other seamless pipes",
      "Large welded tubes - A",
      "Large welded tubes - B",
      "Other welded pipes",
      "Non-alloy and other alloy cold finished bars",
      "Non-alloy wire",
    ],
    []
  );

  const countryList = useMemo(
    () => [
      "Algeria",
      "Australia",
      "Bosnia-Herzegovina",
      "Canada",
      "China",
      "Egypt",
      "India",
      "Indonesia",
      "Iran",
      "Japan",
      "Libya",
      "Macedonia",
      "Malaysia",
      "Moldova",
      "Other",
      "Serbia",
      "South Africa",
      "South Korea",
      "Switzerland",
      "Taiwan",
      "Tunisia",
      "Turkey",
      "United Arab Emirates",
      "United Kingdom",
      "Usa",
      "Vietnam",
    ],
    []
  );

  // 📥 Excel import ve grup oluşturma
  const handleExcelImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // güvenli sheet alma
        const firstSheetName = workbook.SheetNames?.[0];
        if (!firstSheetName) {
          alert("Excel sayfası bulunamadı!");
          return;
        }

        const sheet = workbook.Sheets[firstSheetName];
        if (!sheet) {
          alert("Sheet okunamadı!");
          return;
        }

        // range belirle (fallback'li)
        const rangeRef = sheet["!ref"] || "A1:L10000";
        let range;
        try {
          range = XLSX.utils.decode_range(rangeRef);
        } catch (err) {
          console.warn("⚠️ decode_range hatası:", err);
          range = XLSX.utils.decode_range("A1:L10000");
        }

        // tüm satırları oku
        const rows = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          defval: "",
          blankrows: true,
          range,
        });

        // --- GRUPLAMA ---
        const grouped = [];
        let currentGroup = null;

        rows.forEach((r) => {
          const [colA, colB, colC] = r;

          // Başlık tespiti: A dolu, B ve C boş
          if (
            (colA?.trim() || "") &&
            (!colB || colB === "") &&
            (!colC || colC === "")
          ) {
            currentGroup = { title: colA.trim(), data: [] };
            grouped.push(currentGroup);
            return;
          }

          // Geçerli grup yoksa atla
          if (!currentGroup) return;

          // Normal veri satırı
          currentGroup.data.push({
            country: r[0] || "",
            code: r[1] || "",
            startDate: r[2] || "",
            endDate: r[3] || "",
            amount: r[4] || "",
            balance: r[5] || "",
            usedVolume: r[6] || "",
            awaiting: r[7] || "",
            usedPercent: r[8] || "",
            lastImport: r[9] || "",
            lastAllocation: r[10] || "",
            exhaustion: r[11] || "",
          });
        });
        console.log("121211211", grouped);
        setParsedData(grouped);
        setSelectedProducts(productList);
        setSelectedCountries(countryList);

        console.log(" Gruplanmış veri:", grouped);
      } catch (err) {
        console.error("❌ Excel okuma hatası:", err);
        alert("Excel okunamadı, lütfen dosyayı kontrol et.");
      }
    };

    reader.readAsArrayBuffer(file);
  };

  //  Filtreleme işlemleri
  const handleProductSelect = (p) =>
    setSelectedProducts((prev) =>
      prev.includes(p) ? prev.filter((x) => x !== p) : [...prev, p]
    );

  const handleCountrySelect = (c) =>
    setSelectedCountries((prev) =>
      prev.includes(c) ? prev.filter((x) => x !== c) : [...prev, c]
    );

  const filteredData = parsedData
    .filter((t) => selectedProducts.includes(t.title))
    .map((t) => ({
      ...t,
      data: t.data.filter((r) => selectedCountries.includes(r.country)),
    }));

  const exportSteelOneExcel = async (filteredData = []) => {
    if (!filteredData || filteredData.length === 0) {
      alert("⚠️ Export edilecek veri bulunamadı!");
      return;
    }

    const wb = new ExcelJS.Workbook();

    // 🎨 Stil ayarları
    const headerStyle = {
      font: { bold: true, color: { argb: "FFFFFFFF" } },
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4472C4" },
      },
      border: {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    // 📋 Yeni kolon başlıkları (B Planı Formatı)
    const headers = [
      "Country",
      "Amount",
      "Balance",
      "Used Volume",
      "Awaiting",
      "Used (%)",
    ];

    // 🧩 Her grup için ayrı sheet
    for (const group of filteredData) {
      const ws = wb.addWorksheet(group.title?.substring(0, 31) || "Sheet");
      const headerRow = ws.addRow(headers);
      headerRow.eachCell((cell) => Object.assign(cell, { style: headerStyle }));

      // 🔢 Satır verileri (formatlı)
      group.data.forEach((item) => {
        const row = ws.addRow([
          item.country,
          Number(item.amount || 0),
          Number(item.balance || 0),
          Number(item.usedVolume || 0),
          Number(item.awaiting || 0),
          Number(item.usedPercent || 0),
        ]);

        row.eachCell((cell, idx) => {
          cell.border = border;
          cell.alignment = { horizontal: "center", vertical: "middle" };

          if ([2, 3, 4, 5].includes(idx)) cell.numFmt = "#,##0"; // Amount, Balance, Used Volume, Awaiting
          if (idx === 6) cell.numFmt = "0.00"; // Used (%)
        });
      });

      // 📏 Otomatik kolon genişliği
      ws.columns.forEach((col) => {
        let maxLength = 0;
        col.eachCell({ includeEmpty: true }, (cell) => {
          const len = cell.value ? cell.value.toString().length : 10;
          maxLength = Math.max(maxLength, len);
        });
        col.width = maxLength + 2;
      });
    }

    // 💾 Excel kaydet
    const buffer = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `SteelOne_BPlan_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Çelik Ürünleri Excel Import EU (B Planı)</h2>

      {/* 📂 Dosya yükleme */}
      <Row className="align-items-center mb-4">
        <Col md={4}>
          <Form.Group controlId="formFile">
            <Form.Label className="fw-bold">Excel Dosyası Yükle</Form.Label>
            <Form.Control
              type="file"
              accept=".xlsx,.xls"
              onChange={handleExcelImport}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Button
            variant="success"
            onClick={() => exportSteelOneExcel(filteredData)}
          >
            📤 Excel’e Aktar
          </Button>
        </Col>
      </Row>

      {parsedData.length > 0 && (
        <>
          {/*  Filtre Barı */}
          <Row className="mb-4">
            <Col md={5}>
              <h5 className="fw-bold">Products</h5>
              <div
                style={{
                  height: "160px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "5px",
                }}
              >
                {productList.map((p) => (
                  <Form.Check
                    key={p}
                    type="checkbox"
                    label={p}
                    checked={selectedProducts.includes(p)}
                    onChange={() => handleProductSelect(p)}
                    style={{ fontSize: "13px", margin: "3px" }}
                  />
                ))}
              </div>
            </Col>

            <Col md={5}>
              <h5 className="fw-bold">Countries</h5>
              <div
                style={{
                  height: "160px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "5px",
                }}
              >
                {countryList.map((c) => (
                  <Form.Check
                    key={c}
                    type="checkbox"
                    label={c}
                    checked={selectedCountries.includes(c)}
                    onChange={() => handleCountrySelect(c)}
                    style={{ fontSize: "13px", margin: "3px" }}
                  />
                ))}
              </div>
            </Col>

            <Col md={2} className="d-flex flex-column justify-content-end">
              <Button
                className="mb-2"
                variant="secondary"
                onClick={() => {
                  setSelectedProducts(productList);
                  setSelectedCountries(countryList);
                }}
              >
                Tümünü Seç
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => {
                  setSelectedProducts([]);
                  setSelectedCountries([]);
                }}
              >
                Temizle
              </Button>
            </Col>
          </Row>

          {filteredData.map((sheet, index) => (
            <div key={index} className="mb-5">
              <h5 className="fw-bold mb-3">{sheet.title}</h5>
              <div className="table-responsive">
                <Table striped bordered hover size="sm">
                  <thead className="table-secondary">
                    <tr>
                      <th>Country</th>
                      <th className="text-end">Amount</th>
                      <th className="text-end">Balance</th>
                      <th className="text-end">Used Volume</th>
                      <th className="text-end">Awaiting</th>
                      <th className="text-end">Used (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sheet.data.length > 0 ? (
                      sheet.data.map((row, i) => (
                        <tr key={i}>
                          <td>{row.country}</td>
                          <td className="text-end">
                            {Number(row.amount).toLocaleString("en-US")}
                          </td>
                          <td className="text-end">
                            {Number(row.balance).toLocaleString("en-US")}
                          </td>
                          <td className="text-end">
                            {Number(row.usedVolume).toLocaleString("en-US")}
                          </td>
                          <td className="text-end">
                            {Number(row.awaiting).toLocaleString("en-US")}
                          </td>
                          <td className="text-end">
                            {Number(row.usedPercent).toFixed(2)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center text-muted">
                          Veri bulunamadı
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          ))}
        </>
      )}

      {parsedData.length === 0 && (
        <p className="text-muted">Henüz bir Excel dosyası yüklenmedi.</p>
      )}
    </Layout>
  );
}

export default SteelOneBPlani;
